import React from 'react';
import PropTypes from 'prop-types';
import { Check } from './constants';

import './SuccessBanner.scss';

const SuccessBanner = ({ type }) => {
    if (type === 'none') return null;

    const determineBannerMessage = (messageType) => {
        if (messageType === 'new') return 'Your post is published!';
        if (messageType === 'edit') return 'Updates saved!';
        return '';
    };

    return (
        <div className="component-UnifiedPostCard-SuccessBanner">
            <span className="banner-check-icon">
                <Check />
            </span>
            <span className="banner-message">
                {determineBannerMessage(type)}
            </span>
        </div>
    );
};

SuccessBanner.propTypes = {
    type: PropTypes.oneOf(['new', 'edit', 'none']),
};

SuccessBanner.defaultProps = {
    type: 'none',
};

SuccessBanner.displayName = 'SuccessBanner';

export default SuccessBanner;
